import { Box, Slider, Typography } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import useStyles, { sliderSx } from './_styles'
import { TransmissionSliderProps } from './_props'
import { clamp, snapToStep, getSliderNumber, resolveInitialValue } from '../../utils/number'

// slider from material ui
export default function TransmissionSlider({ question, initialValue, onAnswer }: TransmissionSliderProps) {
    const classes = useStyles()
    const { minimumValue, maximumValue, step } = question
    const [value, setValue] = useState<number>(() => resolveInitialValue(initialValue, minimumValue, maximumValue))

    useEffect(() => {
        const next = resolveInitialValue(initialValue, minimumValue, maximumValue)
        setValue(next)
        onAnswer?.(snapToStep(next, minimumValue, step))
    }, [question.id])

    const marks = useMemo(() => {
        const range = maximumValue - minimumValue
        const count = maximumValue - 1
        if (range <= 0 || count <= 0) return []

        return Array.from({ length: count }, (_, i) => ({
            value: minimumValue + (range * (i + 1)) / (count + 1),
        }))
    }, [minimumValue, maximumValue])

    return (
        <Box sx={{ maxWidth: 640, margin: '0 auto' }}>
            <Box sx={sliderSx.transmissionSliderContainer}>
                <Slider
                    value={value}
                    min={minimumValue}
                    max={maximumValue}
                    step={step}
                    marks={marks}
                    valueLabelDisplay="on"
                    valueLabelFormat={(v) => `${v}/${maximumValue}`}
                    onChange={(_, newValue) => {
                        setValue(clamp(getSliderNumber(newValue), minimumValue, maximumValue))
                    }}
                    onChangeCommitted={(_, newValue) => {
                        const next = snapToStep(
                            clamp(getSliderNumber(newValue), minimumValue, maximumValue),
                            minimumValue,
                            step,
                        )
                        setValue(next)
                        onAnswer?.(next)
                    }}
                    sx={{ ...sliderSx.slider, color: '#5B57D6', height: 12 }}
                />
                <Box sx={sliderSx.sliderValueContainer}>
                    <Typography sx={sliderSx.sliderValueLabel}>{minimumValue}</Typography>
                    <Typography sx={sliderSx.sliderValueLabel}>{maximumValue}</Typography>
                </Box>
            </Box>
        </Box>
    )
}
